import {
    ChangeDetectionStrategy,
    Component,
    HostListener,
    OnInit,
    TemplateRef,
    inject,
    input,
    output,
} from '@angular/core'
import { TbMenuState } from '@components-library/tb-menu'
import { ModalLayoutComponent } from '@components-library/tb-modal-manager/modal-layout/modal-layout.component'
import { ModalContainerTypes } from '@components-library/tb-modal-manager/modal-manager.service'
import { TranslocoDirective } from '@jsverse/transloco'
import { ScrollingModule } from '@nomad2102npm/cdk/scrolling'

import { chunk } from 'lodash-es'
import { TbButtonComponent } from '../tb-button/tb-button.component'
import { NgTemplateOutlet } from '@angular/common'
import { TbMenuComponent } from '../tb-menu/tb-menu.component'
import { BreakpointService } from '@components-library/services/breakpoint.service'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
    selector: 'app-tb-picker',
    templateUrl: './tb-picker.component.html',
    styleUrl: './tb-picker.component.sass',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TbMenuComponent,
        NgTemplateOutlet,
        TbButtonComponent,
        ModalLayoutComponent,
        TranslocoDirective,
        ScrollingModule,
    ],
})
export class TbPickerComponent<T> implements OnInit {
    private readonly breakpointService = inject(BreakpointService)

    protected readonly ModalContainer = ModalContainerTypes

    itemTemplate = input.required<TemplateRef<any>>()

    items = input.required<T[]>()

    titleKey = input.required<string>()

    subtitle = input.required<string>()

    name = input<string>()

    selectedItem = input<T | null>(null)

    showClear = input(false)

    large = input(false)

    baseNumbersInLine = input(8)

    selectItem = output<T | null>()

    opened = false

    innerItems!: T[][]

    menuSize = ''

    @HostListener('window:resize')
    onResize() {
        this.innerItems = this.getInnerItems()
    }

    ngOnInit() {
        this.innerItems = this.getInnerItems()

        this.breakpointService.displaySize$
            .pipe(untilDestroyed(this))
            .subscribe(() => (this.innerItems = this.getInnerItems()))

        this.menuSize = this.getMenuSize()
    }

    isMenuOpened(status: TbMenuState) {
        this.opened = status === TbMenuState.Open
    }

    selectPickerItem(rowIndex: number, itemIndex: number, item: T) {
        if (this.showClear() && rowIndex === 0 && itemIndex === 0) {
            this.selectItem.emit(null)
            return
        }

        this.selectItem.emit(item)
    }

    private getInnerItems() {
        return chunk(this.updatedItemsArray(), this.getNumbersInLine())
    }

    private getNumbersInLine() {
        if (!this.breakpointService.isSmallSize) return this.baseNumbersInLine()

        return Math.floor((window.innerWidth - 40) / (this.large() ? 48 : 54))
    }

    private updatedItemsArray() {
        if (this.showClear()) {
            return ['clear' as T, ...this.items()]
        }
        return [...this.items()]
    }

    private getMenuSize() {
        return this.large() ? 'w-[25.5rem] h-[15.625rem]' : 'w-[28.5rem] h-40'
    }
}
